export class NgxGalleryImageSize {
  static Cover = "cover";
  static Contain = "contain";
}



// WEBPACK FOOTER //
// /agir/src/app/components/ngx-gallery/ngx-gallery-image-size.model.ts